export class GetDscrData {
  static readonly type = '[Dscr] GetDscrData';
  constructor(
    public borrowerId: number
  ) {}
}
